function main(passMultiplayerCheck, onStartCallback, skipLogic) //this is where the next trial is selected and presented
{
  hideAll();//either here or at the end of the previous trial
  prevScreenType = screenType;
  screenType = "test";//default

  changeDesignDefault();
  if(screen_general=="on" && !window.inPreviewMode){showGeneral();}
  else if(screen_calibrate=="on" && !window.inPreviewMode){showCalibrate();}
  else if(screen_infosheet=="on" && !window.inPreviewMode && window.infosheet_type) {showInformationScreen();}
  // else if((screen_consent=="on" || screen_consent == "1") && !window.inPreviewMode){showConsent();}
  else if(screen_consent=="on" && !window.inPreviewMode){showConsent2();}
  else if(screen_pdetails=="on" && !window.inPreviewMode){showPdetails();}
  else if(shouldCalibrateMic() && !window.inPreviewMode){showMicCalibration();}
  else if(shouldBenchmarkFramerate() && !window.inPreviewMode){showFramerateBenchmark();}
  else if( !window.seenEnableMediaAutoPlay && projectHasMedia(window.listStimType)){showEnableMediaAutoPlay();}
  else if(screen_fullscreen && !window.inPreviewMode){showFullScreen();}

  else if(trial==noTrialsGroup-1 && columnForTrial('then', window.trialRow) == 'na' && columnForTrial('break', window.trialRow) == 'na') {
    if (window.multiplayer && isMultiplayerTrial(stimOrder[trial])) {
      const arenaInfo = getMultiplayerInfo(stimOrder[trial]);
      //this user is ready for next trial
      window.multiplayer.setReadyForTrialRow(stimOrder[trial], arenaInfo, function () {
        theEnd();
      });
      return;
    }

    theEnd();
  
  } else {
    if (trial == -1 && window.multiplayer && !window.screen_pdetails_was_visible) {
       testableTriggerEvent(window.events.doneExperimentSetup, {
        name: null,
        age: null,
        gender: null
      });
    }

    if (window.inPreviewMode && trial === -1 && !window.onceLoadedCalled) {
      window.onceLoadedCalled = true;
      const sendLoaded = () => {
            // if the previewer is not ready, then we postpone loaded signal
            if (!window.parent || !window.parent.thePreviewer) {
                setTimeout(sendLoaded, 100);
                return;
            }
            // let the previewer know that we have loaded
            window.parent && window.parent.postMessage({
                testable: true,
                loaded: true,
            });
      };

      sendLoaded();
    }

    var nextTrialRow = stimOrder[trial + 1];

    if (window.multiplayerUI) {
      if(!isMultiplayerTrial(nextTrialRow)){
        window.multiplayerUI.hideMultiplayer();
      }
      else{
        // not sure tha we need this???
        window.multiplayerUI.showMultiplayer();
      }
    }

    //multiplayer semaphore - called from experiment code
    if (!passMultiplayerCheck && window.multiplayer && isMultiplayerTrial(nextTrialRow)) {
      const arenaInfo = getMultiplayerInfo(nextTrialRow);
      //this user is ready for next trial
      window.multiplayer.setReadyForTrialRow(nextTrialRow, arenaInfo);
      return;
    }
    //move on to next trial
    feedbackScreen = 0;
    trial = trial + 1; console.log('trial:'+trial);
    window.savedResponseThisTrial = false;

    //init storage after calibration
    if(trial == 0){
      initStorage();
    }

      try {

        if (!window.trialRow) {
            window.trialRow = 0;
        }

        window.trialActualValues = {};
        trialRow = getNextTrialRowNumber(trial, window.trialRow, skipLogic); console.log('trialRow:' + trialRow);
        // if we have an expanding trial
        window.dynamicLists.expandTrial(
            window.trialData.trialDynamicLists,
            window.trialRow,
            window.dynamicLists.dynamicListsValues,
        );

        if (window.dynamicLists.dynamicListsValues[trialRow]) {
            let oncePerTrial = true;
            for (const [expandingColumn, values] of Object.entries(window.dynamicLists.dynamicListsValues[trialRow])) {
                // if trial has just been expanded, add generated trials to the stimOrder
                if (oncePerTrial && values.length > 1) {
                    window.noTrials++;
                    window.noTrialsGroup++;
                    // window.trialRow  = window.trialRow;
                    // add trial to stimOrder at current position
                    window.stimOrder.splice(trial, 0, trialRow);
                    oncePerTrial = false;
                }

                const value = window.dynamicLists.getDynamicValue(expandingColumn);
                window.trialActualValues[expandingColumn] = value;
            }
        }

        //handle breaks
        if(window.screenedOut === true) {
          window.showScreenout();
          return;
        }
        if(window.isBreakTrial(trialRow)){
          window.jumpOverBreakTrial();
        }
        var nextBreak = getNextBreak();
        if(nextBreak){
          window.startBreak(nextBreak.row);
        }
        else if(window.inBreakTrial){
          window.endBreak();
          window.elapsedTrials--;
        }

        if(window.hasScreenout && !window.reachedScreenout) {
          window.reachedScreenout = true;
          window.logExperimentEvent(window.consortEvents.STARTED_SCREENOUT);
        }

        //see if we just exitted screenout
        if(window.hasScreenout && !window.screenOutPassed && trialRow > window.lastScreenoutRow && columnForTrial('then', trialRow).indexOf('screenout') === -1) {
          window.screenOutPassed = true;
          window.logExperimentEvent(window.consortEvents.PASSED_SCREENOUT);
        }

        window.elapsedTrials++;
      } catch (e) {
        console.log('errrr', e);
        trialRow = window.stimOrder[trial];
        Bugsnag && Bugsnag.notify(e);
      }

      if (typeof trialRow == 'undefined') { theEnd(); return;}

    if (window.inPreviewMode) {
      window.parent && window.parent.postMessage({
        testable: true,
        trialRow: window.trialData.trialFileRows[trialRow],
      });
    }

    if (onStartCallback) {
      const arenaInfo = getMultiplayerInfo(trialRow);
      onStartCallback(arenaInfo);
    }

    if(trial!=0){hideAll();};//check all tests work only with this after removing same command from function showTrial()

    if (trial > 0 && listArrays[allColumns.indexOf('type')][stimOrder[trial-1]] == "test" && listArrays[allColumns.indexOf('type')][stimOrder[trial]] != "test"){iTestBlock++;}

      if (trial > 0 && listBlockNo[stimOrder[trial]] == listBlockNo[stimOrder[trial-1]]) {iBlock++;} else {iBlock=1;} //which trial in each block

window.presTime_actual_temp = [];
window.realISI_temp = [];

trialInfo = {};
trialInfo["target"] = {};
trialInfo["target"].width = Math.round(adjuster * (images[0][trialRow].width | 0) );
trialInfo["target"].height = Math.round(adjuster * (images[0][trialRow].height | 0));
trialInfo["target"].halfWidth = Math.round((trialInfo["target"].width | 0)/2);
trialInfo["target"].halfHeight = Math.round((trialInfo["target"].height | 0)/2);

   halfCanvasWidth = Math.round(canvasWidth/2);
   halfCanvasHeight = Math.round(canvasHeight/2);


  //compute image vertical/horizontal shifts if defined in the spreadsheet
  window.stimPosList = [];
  if (listArrays[allColumns.indexOf('stimPos')][trialRow] !== "na") {
    var stimPosValue = listArrays[allColumns.indexOf('stimPos')][trialRow];
    stimPosList = computePositionBlocks(stimPosValue, halfCanvasWidth, halfCanvasHeight);
  }

for (var i = 1; i <= window.stimFieldsMax; i++)
{
  var key = "image"  + i;
  trialInfo[key] = {};
  //compute image size or take it from the spreadsheet
  const stimSizeFunctions = listStimSizeFunctions[trialRow];
  if (!stimSizeFunctions || !stimSizeFunctions[i - 1]){
    trialInfo[key].width = Math.round(adjuster * images[i][trialRow].width);
    trialInfo[key].height = Math.round(adjuster * images[i][trialRow].height);
  } else if(!isTrialOfType(trialRow, 'word')){
    const newSizes = stimSizeFunctions[i - 1](images[i][trialRow].width, images[i][trialRow].height);
    trialInfo[key].width = Math.round(adjuster * newSizes.width);
    trialInfo[key].height = Math.round(adjuster * newSizes.height);
  }
  
  trialInfo[key].halfWidth = Math.round(trialInfo[key].width/2);
  trialInfo[key].halfHeight = Math.round(trialInfo[key].height/2);


  trialInfo[key].vertShift = undefined;
  trialInfo[key].horizShift = undefined;

  var shift = getTrialShift(i-1, stimPosList);
  if (shift) {
      trialInfo[key].horizShift = Math.round(adjuster * shift.pos.horizontal);
      trialInfo[key].vertShift = Math.round(adjuster * shift.pos.vertical);
      trialInfo[key].shiftInfo = shift;
      if (!shift.isStartBlock && trialInfo[key].width > 0) {
        //update block size only if there is an image here
        trialInfo['image' + (shift.fromIndex + 1)].shiftInfo.blockSize = i - shift.fromIndex;
      }
  }
}
trialInfo["mask"] = {};
trialInfo["mask"].width = Math.round(adjuster * images[window.imageColumns.length - 1][trialRow].width);
trialInfo["mask"].height = Math.round(adjuster * images[window.imageColumns.length - 1][trialRow].height);
trialInfo["mask"].halfWidth = Math.round(trialInfo["mask"].width/2);
trialInfo["mask"].halfHeight = Math.round(trialInfo["mask"].height/2);

trialInfo.maxImageWidth = Math.max(trialInfo.image1.width,trialInfo.image2.width,trialInfo.image3.width,trialInfo.image4.width,trialInfo.image5.width,trialInfo.image6.width);
trialInfo.maxImageHeight = Math.max(trialInfo.image1.height,trialInfo.image2.height,trialInfo.image3.height,trialInfo.image4.height,trialInfo.image5.height,trialInfo.image6.height);

    imageTargetWidth = Math.round(adjuster * images[0][trialRow].width);
    image1width = Math.round(adjuster * images[1][trialRow].width);
    image2width = Math.round(adjuster * images[2][trialRow].width);
    image3width = Math.round(adjuster * images[3][trialRow].width);
    image4width = Math.round(adjuster * images[4][trialRow].width);
    image5width = Math.round(adjuster * images[5][trialRow].width);
    image6width = Math.round(adjuster * images[6][trialRow].width);
    imageMaskWidth = Math.round(adjuster * images[window.imageColumns.length - 1][trialRow].width);
    width = image1width;
    maxImageWidth = Math.max(image1width,image2width,image3width,image4width,image5width,image6width);

    imageTargetHeight = Math.round(adjuster * images[0][trialRow].height);
    image1height = Math.round(adjuster * images[1][trialRow].height);
    image2height = Math.round(adjuster * images[2][trialRow].height);
    image3height = Math.round(adjuster * images[3][trialRow].height);
    image4height = Math.round(adjuster * images[4][trialRow].height);
    image5height = Math.round(adjuster * images[5][trialRow].height);
    image6height = Math.round(adjuster * images[6][trialRow].height);
    imageMaskHeight = Math.round(adjuster * images[window.imageColumns.length - 1][trialRow].height);
    height = image1height;
    maxImageHeight = Math.max(image1height,image2height,image3height,image4height,image5height,image6height);


    window.runUserScript(trialRow, userScriptEvents.start);


    window.logExperimentEvent(window.consortEvents.STARTED_TRIAL);
    showPreloadedTrial();
  }
}


function getTrialShift(index, stimPosList) {
  console.log('pos for index', index, 'from ', stimPosList);
  var initialIndex = index;
  //find the first available shift searching from index down to first available position
  while (!stimPosList[index] /*&& !stimPosList[index + 1] */ && index >= 0) {
    index--;
  }

  if (stimPosList[index]) {
    return {pos: stimPosList[index], fromIndex: index, isStartBlock: index == initialIndex, blockSize: 1};
  }

  return null;
}



//returns the list of shifts computed (random handled)
function computePositionBlocks(stimPosValue, halfCanvasWidth, halfCanvasHeight) {
  var stimPosList = [];
  var stimPos = stimPosValue.split(';');

  for (var i = 0; i < stimPos.length; i++) {
    var pos = null;
    if (stimPos[i].length) {
      var pointDefinition = computePointDefinition(stimPos[i]);
      var posCoords = pointDefinition.split(' ').filter(function(c) {return c.length != 0});
      pos = {
          horizontal: posCoords[0] ? computeCoordInt(posCoords[0], halfCanvasWidth, halfCanvasHeight)  : 0,
          vertical:   posCoords[1] ? computeCoordInt(posCoords[1], halfCanvasWidth, halfCanvasHeight)  : 0
        };
    }
    stimPosList.push(pos);
  }

  console.log('stimposlist', stimPosList);

  return stimPosList;

  function computePointDefinition(pointsDefinitions) {
    if (pointsDefinitions.indexOf('(') === -1) {
      //points not found - single point
      return pointsDefinitions.trim();
    }

    // multiple points
    var points = computeAllPointsDefinitions(pointsDefinitions);
    return getRandomArrayValue(points).trim();
  }

  function computeAllPointsDefinitions(pointsDefinitions) {
    const regex = /\(([^\)\(]+)\)(\s*\|\s*|$)/gm;
    var points = [];

    while ((m = regex.exec(pointsDefinitions)) !== null) {
        // This is necessary to avoid infinite loops with zero-width matches
        if (m.index === regex.lastIndex) {
            regex.lastIndex++;
        }
        points.push(m[1]);
    }

    return points;
  }

  function computeCoordInt(coord, halfCanvasWidth, halfCanvasHeight) {
    var positionKeywords = {
      'center': 0,
      'left': -halfCanvasWidth,
      'right': halfCanvasWidth,
      'top': -halfCanvasHeight,
      'bottom': halfCanvasHeight
    }

    // it does not work with alternatives like left|right
    if (positionKeywords[coord] !== undefined) {
      console.log('position by keyword', coord, positionKeywords[coord]);
      return positionKeywords[coord];
    }

    // handle interval
    //should be done sooner than alternatives options
    var matchResult = null;
    if (matchResult = coord.match(/^(\-?\d+)_(\-?\d+)$/) ) {
        var min = matchResult[1];
        var max = matchResult[2];
        var pos = getRandomInteger(min, max);

        console.log('position by random in interval', coord, min, max, pos);
        return pos;
    }

    //handle simple alternatives like 100|200|300
    var options = [];
    if ((options = coord.match(/\|?\-?\d+/g)) && options.length > 1) {

      var randomPosition = getRandomInteger(0, options.length - 1);
      var pos = options[randomPosition];
      var startStringPos = pos.substr(0, 1) == '|' ? 1 : 0;

      console.log('position by random options', coord, parseInt(pos.substr(startStringPos)));
      return parseInt(pos.substr(startStringPos));
    }

    console.log('position by specific value', coord, parseInt(coord));

    return parseInt(coord)
  }
}

function isMultiplayerTrial(trialRow) {
  return columnForTrial('arena', trialRow) != 'na';
}

function canAdvanceIfMultiplayer(nextTrialRow) {
  return window.Multiplayer && isMultiplayerTrial(nextTrialRow) && window.multiplayer && multiplayer.canStartTrial(nextTrialRow);
}


function getMultiplayerInfo(trialRow) {
  var arenaInfo = {};
  var current_multiplayerColumns = window.multiplayerColumns;
  current_multiplayerColumns.push('type', 'stim1', 'stimFormat', 'responseOptions');
  for (var i = 0; i < current_multiplayerColumns.length; i++) {
    var columnName = current_multiplayerColumns[i];
    var columnValue = columnForTrial(columnName, trialRow);
    if (columnValue == 'na') {
      columnValue = null;
    }

    arenaInfo[columnName] = columnValue
  }

  return arenaInfo;
}
